<template>
  <div class="input-group">
    <select
      v-model="operation"
      :disabled="nothingSelected('files')"
      class="form-control"
      :name="operationFieldName">
      <option v-for="option in operationOptions" :value="option.operation">{{ option.name }}</option>
    </select>
    <span class="input-group-append">
      <template v-if="operation === 'download-files'">
        <input :disabled="nothingSelected('files')"
          class="btn btn-primary" type="submit" value="Download" />
      </template>
      <input v-else
        :disabled="nothingSelected('files') || operation === ''"
        class="btn btn-primary" type="button" value="Apply" @click="applyOperation" />
    </span>
  </div>

  <modal :id="deleteModalId" title="Delete Claim Uploads">
    <div class="text-center">
      <p>Are you sure you want to delete {{ selectedCount }} claim upload{{ selectedCount > 1 ? 's' : '' }}?</p>
    </div>

    <template #footer>
      <div>
        <button type="button" class="btn btn-default" @click="$modal.hide(deleteModalId)"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="button" class="btn btn-danger" @click="confirmDeletion" :disabled="deletionConfirmed"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </div>
    </template>
  </modal>

  <email-compose
    ref="emailCompose"
    :claim-id="claimId"
    :modal-id="emailModalId"
    :allow-manage-lookup-email-item="allowManageLookupEmailItem"
    :uploads="uploadIds"
    :sender-options="senderOptions"
    :sender-signatures="senderSignatures"
    :attachments-max-size="attachmentsMaxSize"
  ></email-compose>

  <wf-export-modal
    :claim-id="claimId"
    :modal-id="wfExportModalId"
    :report-types="wfReportTypes"
    :upload-objects="uploadObjects"
    :upload-ids="uploadIds"
  ></wf-export-modal>
</template>

<script>
  import EmailCompose from "./EmailCompose";
  import WfExportModal from "./modals/WfExportModal.vue";
  import HasModal from "./mixins/HasModal";
  import { mapWritableState, mapState } from 'pinia'
  import { useCheckboxListStore } from "../stores/checkboxList"

  export default {
    mixins: [HasModal],

    props: {
      // Operation form field name.
      operationFieldName: {
        required: true,
        type: String,
      },

      // List of operations available.
      operations: {
        type: Array,
        required: true
      },

      // Claim Id
      claimId: {
        required: true,
        type: String,
      },

      // Uploads form id to submit.
      formId: {
        required: true,
        type: String,
      },

      // Allow user to manage lookup email list items.
      allowManageLookupEmailItem: {
        type: Boolean,
        default: false
      },

      // WF report type list.
      wfReportTypes: {
        type: Array,
        default: () => {return []}
      },

      // All file object list.
      uploadObjects: {
        type: Array,
        default: () => {return []}
      },

      // Custom id for bulk delete modal.
      deleteModalId: {
        type: String,
        default: 'bulkDeleteFilesModal'
      },

      // Custom id for email compose modal component.
      emailModalId: {
        type: String,
        default: 'bulkEmailFilesModal'
      },

      // Custom id for WF export modal component.
      wfExportModalId: {
        type: String,
        default: 'bulkWfExportFilesModal'
      },

      // Senders.
      senderOptions: {
        type: Array,
        default: function () { return [] }
      },

      // Sender signatures.
      senderSignatures: {
        type: Object,
        default: function () { return [] }
      },

      // Modal dialog title.
      attachmentsMaxSize: {
        type: Number,
        default: 5242880
      },

    },

    /**
     * Used components.
     */
    components: {
      EmailCompose,
      WfExportModal
    },

    /**
     * Variables (models).
     */
    data () {
      return {
        operation: '',
        deletionConfirmed: false,
      }
    },

    /**
     * Computed values
     */
    computed: {
      ...mapState(useCheckboxListStore, ['nothingSelected', 'checkedIds']),
      ...mapWritableState(useCheckboxListStore, ['lists']),

      operationOptions() {
        let operations = _.cloneDeep(this.operations);
        operations.unshift({'name': 'Select a group operation…', 'operation': ''});
        return operations;
      },

      uploadIds() {
        return this.checkedIds('files');
      },

      // Count of selected files
      selectedCount() {
        return this.uploadIds.length;
      }
    },

    /**
     * Functions (methods).
     */
    methods: {

      applyOperation() {
        if (this.operation === 'send-email-files') {
          this.$modal.show(this.emailModalId);
        }
        if (this.operation === 'export-to-wf') {
          this.$modal.show(this.wfExportModalId);
        }
        if (this.operation === 'delete-files') {
          this.$modal.show(this.deleteModalId);
        }
      },

      confirmDeletion() {
        this.deletionConfirmed = true;
        this.$modal.hide(this.deleteModalId);
        document.getElementById(this.formId).submit();
      },

    }
  }
</script>
